import { saveFile } from 'CorePackage/MainModule/common/saveFile';

export const getRegulationsFile = (link: string, text: string) => async () => {
  try {
    saveFile(link, text);
  } catch (err) {
    //
  }
};
